import TIMLParser from './timl_parser.js';
import TIMLRenderer from './timl_renderer.js';
import TIMLRuntime from './timl_runtime.js';

export default class TIML {
  static createRenderContext(...args) {
    return TIMLRenderer.createRenderContext(...args);
  }

  static parse(view) {
    return TIMLParser.parse(view);
  }

  static parseLayout(parentView, childView = '', renderContext = this.createRenderContext()) {
    return TIMLRenderer.renderView(parentView, childView, renderContext);
  }

  static renderComponent(componentView, props = {}, renderContext = this.createRenderContext()) {
    return TIMLRenderer.renderComponent(componentView, props, renderContext);
  }

  static renderInto(target, view, props = {}, renderContext = this.createRenderContext()) {
    return TIMLRenderer.renderInto(target, view, props, renderContext);
  }

  static resolvePath(...args) {
    return TIMLRenderer.resolvePath(...args);
  }

  static resolveExpression(...args) {
    return TIMLRenderer.resolveExpression(...args);
  }

  static replaceMustaches(...args) {
    return TIMLRenderer.replaceMustaches(...args);
  }

  static initialPageBuild(...args) {
    return TIMLRuntime.initialPageBuild(...args);
  }

  static loadPageContent(...args) {
    return TIMLRuntime.loadPageContent(...args);
  }

  static setActiveAnchor(...args) {
    return TIMLRuntime.setActiveAnchor(...args);
  }

  static shouldInterceptAnchor(...args) {
    return TIMLRuntime.shouldInterceptAnchor(...args);
  }

  static handleAnchorClick(...args) {
    return TIMLRuntime.handleAnchorClick(...args);
  }

  static clickIntercepter = (...args) => TIMLRuntime.clickIntercepter(...args);

  static handleRedirect(...args) {
    return TIMLRuntime.handleRedirect(...args);
  }

  static remove(...args) {
    return TIMLRuntime.remove(...args);
  }
}
